export type EnvironmentType = 'development' | 'production' | 'rapidapi';